"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TurnStateManager = void 0;
const TurnGame_1 = require("./TurnGame");
const constants_1 = require("./config/constants");
class TurnStateManager {
    constructor() {
        this.gameMaps = new Map();
        this.EVENT = constants_1.EVENT;
        this.START = this.EVENT.START;
        this.PREV_TURN = this.EVENT.PREV_TURN;
        this.NEXT_TURN = this.EVENT.NEXT_TURN;
        this.COMPLETE = this.EVENT.COMPLETE;
        this.END = this.EVENT.END;
    }
    static getInstance() {
        if (!TurnStateManager.instance) {
            TurnStateManager.instance = new TurnStateManager();
        }
        return TurnStateManager.instance;
    }
    setGame(id, options) {
        const game = new TurnGame_1.TurnGame(options);
        this.gameMaps.set(id, game);
        return game;
    }
    getGameFromId(id) {
        const res = this.gameMaps.get(id);
        if (!res) {
            return this.setGame(id, {});
        }
        return res;
    }
    getGamesAll() {
        const res = this.gameMaps.values();
        return Array.from(res);
    }
    getGameIdsAll() {
        const res = this.gameMaps.keys();
        return Array.from(res);
    }
    removeGame(id) {
        if (this.gameMaps.has(id)) {
            this.getGameFromId(id).emit(constants_1.EVENT.END);
            return this.gameMaps.delete(id);
        }
        return false;
    }
    clearGames() {
        this.gameMaps.forEach((value) => {
            value.emit(constants_1.EVENT.END);
        });
        this.gameMaps.clear();
    }
}
exports.TurnStateManager = TurnStateManager;
//# sourceMappingURL=TurnStateManager.js.map